import PackagesLayout from "@/features/packages/packages-layout";
import PackageList from "@/features/packages/PackagesList";
import PackageDetails from "@/features/packages/pages/package-details";
import CreatePackage from "@/features/packages/pages/create-package";
import ImportPackages from "@/features/packages/pages/import-packages";
import TrackingTimeline from "@/features/packages/TrackingTimeline";
import EditPackage from "@/features/packages/pages/edit-package";
import LivreurDashboard from "@/features/packages/components/LivreurDashboard";
import ComprehensiveLivreurDashboard from "@/features/packages/components/ComprehensiveLivreurDashboard";
import ImprovedAdminLivreurManagement from "@/features/packages/components/ImprovedAdminLivreurManagement";
import {
  DeliveryPersonRoute,
  AdminManagerOrClientSupportRoute,
} from "@shared/guards/RoleBasedGuards";

export const packagesRoutes = {
  path: "/packages",
  element: <PackagesLayout />,
  children: [
    {
      path: "/packages",
      element: (
        <>
          <PackageList />
        </>
      ),
    },
    {
      path: "/packages/:id/view",
      element: <PackageDetails />,
    },
    {
      path: "/packages/import",
      element: <ImportPackages />,
    },
    {
      path: "/packages/create",
      element: <CreatePackage />,
    },
    {
      path: "/packages/:id/edit",
      element: <EditPackage />,
    },
    {
      path: "/packages/tracking",
      element: <TrackingTimeline />,
    },
    {
      path: "/packages/livreur/dashboard",
      element: (
        <DeliveryPersonRoute>
          <ComprehensiveLivreurDashboard />
        </DeliveryPersonRoute>
      ),
    },
    {
      path: "/packages/livreur/dashboard-legacy",
      element: (
        <DeliveryPersonRoute>
          <LivreurDashboard />
        </DeliveryPersonRoute>
      ),
    },
    {
      path: "/packages/livreur-management",
      element: (
        <AdminManagerOrClientSupportRoute>
          <ImprovedAdminLivreurManagement />
        </AdminManagerOrClientSupportRoute>
      ),
    },
  ],
};
